import CommentTextSection from "@common/components/CommentTextSection";
import RightDrawer from "@common/components/RightDrawer";
import React from "react";
import { useTranslation } from "react-i18next";

type RoomCommentDrawerProps = {
  comment: string;
  open: boolean;
  onClose: Function;
};

const RoomCommentDrawer = (props: RoomCommentDrawerProps) => {
  const { open, onClose, comment } = props;
  const { t } = useTranslation();

  return (
    <RightDrawer open={open} onClose={() => onClose()} title={t("Room Notes")}>
      <CommentTextSection
        isEdit={false}
        content={comment}
        name="Comments"
        label={""}
        onChange={() => {}}
      />
    </RightDrawer>
  );
};

export default RoomCommentDrawer;
